import PropTypes from 'prop-types'

import { Icon, StackView, Typography } from '@telus-uds/components-web'
// Import commonly used icons directly
import Check from '@telus-uds/palette-allium/build/web/icons/Check'
import Firewall from '@telus-uds/palette-allium/build/web/icons/Firewall'
import Deals from '@telus-uds/palette-allium/build/web/icons/Deals'
import Delivery from '@telus-uds/palette-allium/build/web/icons/Delivery'
import Support from '@telus-uds/palette-allium/build/web/icons/Support'
import Tag from '@telus-uds/palette-allium/build/web/icons/Tag'
import ChatSupport from '@telus-uds/palette-allium/build/web/icons/ChatSupport'
import Preference from '@telus-uds/palette-allium/build/web/icons/Preference'
import Refresh from '@telus-uds/palette-allium/build/web/icons/Refresh'

const ValuePropsItem = ({
  content: {
    fields: { icon = 'Check', title }
  }
}) => {
  // Map icon names to imported icons
  const getUDSIcon = (iconName) => {
    const iconMap = {
      check: Check,
      firewall: Firewall,
      deals: Deals,
      delivery: Delivery,
      support: Support,
      savings: Tag,
      refresh: Refresh,
      chatsupport: ChatSupport,
      preference: Preference
    }

    const normalizedName = iconName.toLowerCase()
    return iconMap[normalizedName]
  }

  return (
    <StackView
      testID="value-props-item"
      space={2}
      direction="row"
      tokens={{
        alignItems: 'center'
      }}
    >
      <Icon icon={getUDSIcon(icon)} variant={{ size: 'large', color: 'brand' }} />
      <Typography>{title}</Typography>
    </StackView>
  )
}

ValuePropsItem.propTypes = {
  content: PropTypes.object.isRequired
}

export default ValuePropsItem
